export default "__VITE_ASSET__8880ded5__"